<div
  class="filter-container mb-4 flex flex-col gap-2"
  (click)="onContainerClick($event)">
  <div class="grid grid-cols-3 gap-6 py-2">
    <!-- Pharmacy Owner -->
    <div *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_PHARMACIST_NAME">
      <app-filter-product-search
        [label]="isArabic() ? 'مالك الصيدلية' : 'Pharmacy Owner'"
        [placeholder]="isArabic() ? 'ابحث باسم المالك...' : 'Search by pharmacy owner name'"
        [loading]="ownerLoading()"
        [error]="ownerError()"
        [results]="ownerResults()"
        [(searchTerm)]="ownerSearchTerm"
        [(showDropdown)]="showOwnerDropdown"
        (searchChange)="onOwnerSearchChange($event)"
        (selectItem)="onOwnerSelect($event)"
        i18n-label="@@adminApprovedPharmaciesFilterOwner"></app-filter-product-search>
    </div>

    <!-- Assigned To -->
    <div *hasScope="SCOPES.PHARMACIES.AUTO_COMPLETE_BY_EMPLOYEE_NAME">
      <app-filter-product-search
        [label]="isArabic() ? 'مُعيّن إلى' : 'Assigned To'"
        [placeholder]="isArabic() ? 'ابحث باسم الموظف...' : 'Search by assigned employee'"
        [loading]="employeeLoading()"
        [error]="employeeError()"
        [results]="employeeResults()"
        [(searchTerm)]="employeeSearchTerm"
        [(showDropdown)]="showEmployeeDropdown"
        (searchChange)="onEmployeeSearchChange($event)"
        (selectItem)="onEmployeeSelect($event)"
        i18n-label="@@adminApprovedPharmaciesFilterAssignedTo"></app-filter-product-search>
    </div>

    <!-- Pharmacy Segment -->
    <app-filter-multi-select
      *hasScope="SCOPES.PHARMACIES.READ_ALL_SEGMENTS"
      [label]="{ titleAr: 'شريحة الصيدلية', titleEn: 'Pharmacy Segment' }"
      [placeholder]="{ titleAr: 'اختر الشريحة', titleEn: 'Choose Segment' }"
      [items]="segmentOptions()"
      [(selectedIds)]="selectedSegmentIds"
      [showDropdown]="showSegmentDropdown()"
      (toggleDropdown)="toggleSegmentDropdown()"
      (selectionChange)="selectedSegmentIds.set($event)"></app-filter-multi-select>

    <!-- Governorate -->
    <app-filter-multi-select
      *hasScope="SCOPES.PHARMACIES.READ_ALL_GOVERNORATES"
      [label]="{ titleAr: 'المحافظة', titleEn: 'Governorate' }"
      [placeholder]="{ titleAr: 'اختر المحافظة', titleEn: 'Choose Governorate' }"
      [items]="governorateOptions()"
      [(selectedIds)]="selectedGovernorateIds"
      [showDropdown]="showGovernorateDropdown()"
      (toggleDropdown)="toggleGovernorateDropdown()"
      (selectionChange)="onGovernorateChange($event)"></app-filter-multi-select>

    <!-- City -->
    <app-filter-select-component
      *hasScope="SCOPES.PHARMACIES.READ_ALL_CITIES"
      [label]="isArabic() ? 'المدينة' : 'City'"
      [defaultOption]="isArabic() ? 'كل المدن' : 'All Cities'"
      [options]="cityOptions()"
      [(value)]="selectedCityId"
      (valueChange)="onCityChange($event)"></app-filter-select-component>

    <!-- Region -->
    <app-filter-select-component
      *hasScope="SCOPES.PHARMACIES.READ_ALL_REGIONS"
      [label]="isArabic() ? 'المنطقة' : 'Region'"
      [defaultOption]="isArabic() ? 'كل المناطق' : 'All Regions'"
      [options]="regionOptions()"
      [(value)]="selectedRegionId"></app-filter-select-component>

    <!-- Min Credit -->
    <app-filter-input
      [label]="isArabic() ? 'الحد الأدنى للرصيد (ج.م)' : 'Min Credit (EGP)'"
      placeholder="0"
      type="number"
      [(value)]="minCredit"></app-filter-input>

    <!-- Max Credit -->
    <div class="flex flex-col gap-1">
      <app-filter-input
        [label]="isArabic() ? 'الحد الأقصى للرصيد (ج.م)' : 'Max Credit (EGP)'"
        placeholder="0"
        type="number"
        [(value)]="maxCredit"></app-filter-input>
      @if (creditRangeInvalid()) {
        <p class="filter-error text-[12px]">
          {{
            isArabic()
              ? "يجب أن يكون الحد الأقصى للقيمة أكبر من أو يساوي الحد الأدنى للقيمة."
              : "Max credit must be greater than or equal to min credit."
          }}
        </p>
      }
    </div>

    <div></div>
    <!-- Created From -->
    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء من' : 'Created From'"
      [value]="createdOnFrom()"
      (valueChange)="createdOnFrom.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <!-- Created To -->
    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ الإنشاء إلى' : 'Created To'"
      [value]="createdOnTo()"
      (valueChange)="createdOnTo.set($event)"
      [isInvalid]="createdDateInvalid()"></app-filter-date-component>

    <!-- @if (createdDateInvalid()) {
      <div class="col-span-3">
        <p class="text-[12px] text-red-500">
          {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية" : "From date cannot be after To date" }}
        </p>
      </div>
    } -->
    <div></div>
    <!-- Last Modified From -->
    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ آخر تعديل من' : 'Last Modification Date From'"
      [value]="lastModifiedOnFrom()"
      (valueChange)="lastModifiedOnFrom.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <!-- Last Modified To -->
    <app-filter-date-component
      [label]="isArabic() ? 'تاريخ آخر تعديل إلى' : 'Last Modification Date To'"
      [value]="lastModifiedOnTo()"
      (valueChange)="lastModifiedOnTo.set($event)"
      [isInvalid]="lastModifiedDateInvalid()"></app-filter-date-component>

    <!-- @if (lastModifiedDateInvalid()) {
      <div class="col-span-3">
        <p class="text-[12px] text-red-500">
          {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية" : "From date cannot be after To date" }}
        </p>
      </div>
    } -->
  </div>

  <div class="border-border flex justify-between border-t pt-4">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()"></app-filter-sorting-component>
    <div class="col-span-2 flex items-end justify-end gap-3">
      <!-- <button
        (click)="onResetFilters()"
        class="rounded-[6px] border border-[#C42727] px-5 py-1.5 text-[13px] font-[500] text-[#C42727] hover:cursor-pointer hover:bg-red-50">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </button>
      <button
        (click)="onApplyFilters()"
        class="rounded-[6px] bg-[#C42727] px-5 py-1.5 text-[13px] font-[500] text-white hover:cursor-pointer hover:bg-[#a31f1f]">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </button> -->
      <app-submit-button type="secondary" (click)="onResetFilters()">
        <span i18n="@@adminProductsResetButton">Clear</span>
      </app-submit-button>

      <app-submit-button type="primary" (click)="onApplyFilters()">
        <span i18n="@@adminProductsApplyButton">Apply</span>
      </app-submit-button>
    </div>
  </div>
</div>
